import {useState, useCallback, useMemo} from 'react';

export interface UseModal {
  isOpened: boolean;
  close: () => void;
  open: () => void;
  set: (value: boolean) => void;
}

export default function useModal(initialIsOpened = false, onClose = () => {}): UseModal {
  const [isOpened, setIsOpened] = useState(initialIsOpened);

  const close = useCallback(
    function () {
      setIsOpened(false);
      if (onClose) {
        onClose();
      }
    },
    [onClose]
  );

  const open = useCallback(function () {
    setIsOpened(true);
  }, []);

  return useMemo<UseModal>(
    () => ({
      isOpened,
      close,
      open,
      set: setIsOpened
    }),
    [close, isOpened, open]
  );
}
